import { render, staticRenderFns } from "./ShortText.vue?vue&type=template&id=701ee65c&scoped=true"
import script from "./ShortText.vue?vue&type=script&lang=js"
export * from "./ShortText.vue?vue&type=script&lang=js"
import style0 from "./ShortText.vue?vue&type=style&index=0&id=701ee65c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701ee65c",
  null
  
)

export default component.exports